<template>
  <div class="ordertoolbar">
    <div class="payslip">
      <Balance></Balance>
      <div>
        <div style="line-height:35px; text-align: right">
          Phí: <strong>{{ numberFormat(Math.round(feeAmount * 1000)) }} G</strong>
        </div>
        <div class="total" style="line-height:30px">
          Tổng cộng: <span>{{ numberFormat(total * 1000) }} G</span>

        </div>
      </div>
    </div>
    <div class="toolbar">
      <div class="stage">
        <div style="color:#9a9a9a">
          Kỳ <span style="color:#555">#{{ stageName }}</span> - Thời gian xổ
        </div>
        <div style="text-align: center; font-size: 1.1em">
          {{ drawTime }}
        </div>
      </div>
      <div class="buttons">
        <ion-button class="btn" @click="onOrderClick" color="primary" fill="solid" expand="block" size="large" :disabled="disabledButton">
          <div>
            Mua ngay <br>
            <template v-if="duration && duration.asMilliseconds() > 0">
              <small>Thời gian còn: {{ gameCountDown }}</small>
            </template>
            <template v-else>
              <small>Hết giờ đặt vé</small>
            </template>
          </div>

        </ion-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ordertoolbar {
  color: #222;
  border-top: 1px solid #ccc;
  display: flex;
  flex-direction: column;
  background: #fff;
  .payslip {
    display: flex;
    padding: 0.5vh;
    align-items: center;
    justify-content: space-between;
    .total {
      display: flex;
      justify-self: right;
    }
    span {
      font-weight: bold;
    }
  }
  .toolbar {
    display: flex;
    align-items: center;
    .stage {
      text-align: center;
      width: 50%;
      font-size: 0.9em;
      border: 1px solid #ccc;
      height: 8vh;
      border-radius: 10px;
      margin: 1vw;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
    .buttons {
      flex-grow: 1;
      width: 50%;
    }
  }
}

</style>

<script>
import {
  IonButton,
} from '@ionic/vue';
import { defineComponent } from 'vue';
import Balance from '@/components/Balance';
import authService from "@/services/auth";
import { numberFormat } from '@/utils';

export default defineComponent({
  name: 'PaySlip',
  props: {
    total: {
      type: Number
    },
    feeAmount: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    game: {
      type: String
    },
    stage: {
      type: Number
    },
    addedDuration: {
      type: Number,
      default: 0,
    }
  },
  components: {
    Balance,
    IonButton,
  },
  computed: {
    stageName() {
      if (this.game == 'keno')
        return String(this.stage).padStart(7, '0')
      else
        return String(this.stage).padStart(5, '0')
    },
    disabledButton() {
      if (!this.isLogin) return true;

      if (this.disabled) {
        return true;
      }
      if (!this.duration)
        return true;

      if (this.game === "keno") {
        if (this.duration.asMinutes() >= 8)
          return true;
      }
      return !(this.duration.asMilliseconds() > 0);
    },
    isLogin() {
      return authService.user() && !authService.user().isAnonymous;
    },
  },
  mounted() {
    this.countdown = setInterval(() => {
      if (this.game === "keno") {
        this.drawTime = this.$moment(this.$store.state.fsdb.liveKeno.draw_time).format('DD/MM/YYYY HH:mm')
        this.duration = this.$moment.duration(this.$store.state.fsdb.liveKeno.draw_time - this.$moment.utc() - (60000 + this.addedDuration) );
        if (this.duration.asMinutes() <= 10) {
          this.gameCountDown = this.$moment.utc(this.duration.asMilliseconds()).format("mm:ss");
        } else {
          this.gameCountDown = Math.floor(this.duration.asHours()) + this.$moment.utc(this.duration.asMilliseconds()).format(":mm:ss");
        }
      }
      if (this.game === "power") {
        this.drawTime = this.$moment(this.$store.state.fsdb.livePower.draw_time).format('DD/MM/YYYY HH:mm')
        this.duration = this.$moment.duration(this.$store.state.fsdb.livePower.draw_time - this.$moment.utc() - 1200000);
        this.gameCountDown = Math.floor(this.duration.asHours()) + this.$moment.utc(this.duration.asMilliseconds()).format(":mm:ss");
      }
      if (this.game === "mega") {
        this.drawTime = this.$moment(this.$store.state.fsdb.liveMega.draw_time).format('DD/MM/YYYY HH:mm')
        this.duration = this.$moment.duration(this.$store.state.fsdb.liveMega.draw_time - this.$moment.utc() - 1200000);
        this.gameCountDown = Math.floor(this.duration.asHours()) + this.$moment.utc(this.duration.asMilliseconds()).format(":mm:ss");
      }
      if (this.game === "max3d") {
        this.drawTime = this.$moment(this.$store.state.fsdb.liveMax3d.draw_time).format('DD/MM/YYYY HH:mm')
        this.duration = this.$moment.duration(this.$store.state.fsdb.liveMax3d.draw_time - this.$moment.utc() - 1200000);
        this.gameCountDown = Math.floor(this.duration.asHours()) + this.$moment.utc(this.duration.asMilliseconds()).format(":mm:ss");
      }
      if (this.game === "max3dpro") {
        this.drawTime = this.$moment(this.$store.state.fsdb.liveMax3dpro.draw_time).format('DD/MM/YYYY HH:mm')
        this.duration = this.$moment.duration(this.$store.state.fsdb.liveMax3dpro.draw_time - this.$moment.utc() - 1200000);
        this.gameCountDown = Math.floor(this.duration.asHours()) + this.$moment.utc(this.duration.asMilliseconds()).format(":mm:ss");
      }
      if (this.game === "max4d") {
        this.drawTime = this.$moment(this.$store.state.fsdb.liveMax4d.draw_time).format('DD/MM/YYYY HH:mm')
        this.duration = this.$moment.duration(this.$store.state.fsdb.liveMax4d.draw_time - this.$moment.utc() - 1200000);
        this.gameCountDown = Math.floor(this.duration.asHours()) + this.$moment.utc(this.duration.asMilliseconds()).format(":mm:ss");
      }
      if (this.duration.asMilliseconds() <= 0) {
        this.gameCountDown = 'Đang xổ';
      }
    }, 1000);
  },
  unmounted() {
    clearInterval(this.countdown);
  },
  methods: {
    onOrderClick() {
      this.$emit('confirm-order');
    }
  },
  data() {
    return {
      duration: null,
      countdown: null,
      gameCountDown: '',
      drawTime: '',
    }
  },
  setup() {
    return {
      numberFormat
    }
  }
})

</script>
